export class NotificationReceivedMessage
{
    public notification: any;

    constructor(notification: any) {
        this.notification = notification;
    }
}